import { render, staticRenderFns } from "./mod3CustomerFeedback.vue?vue&type=template&id=2518be44"
import script from "./mod3CustomerFeedback.vue?vue&type=script&lang=js"
export * from "./mod3CustomerFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports